export default "__VITE_ASSET__309af820__"